export default __webpack_public_path__ + "5a17110b2ef184e9c2a6cb8aac8d1fe3.svg";